module.exports = __webpack_public_path__ + "img/pr-2.db80ea1e.png";